import { type FC } from "react";

import { Banner } from "@/components/flexkit/Banner";
import { useOrganization } from "@/queries/organization-queries";
import { OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";

// Maintenance window: April 18, 2026 6:05 AM UTC (with 5 min buffer).
// Remove this component after the maintenance is complete.
const MAINTENANCE_END = new Date("2026-04-18T06:05:00Z");

export const MaintenanceBanner: FC = () => {
    const { data: organization } = useOrganization();

    if (!organization) {
        return null;
    }

    const tier = organization.tier;
    if (tier !== OrganizationTier.FREE_ONA && tier !== OrganizationTier.CORE) {
        return null;
    }

    if (Date.now() > MAINTENANCE_END.getTime()) {
        return null;
    }

    return (
        <Banner
            variant="announcement"
            data-testid="maintenance-banner"
            className="max-h-24 shrink-0 overflow-hidden duration-500 ease-out animate-in fade-in [&>div]:flex-initial"
            text={
                <span className="line-clamp-3 pr-0.5 duration-700 ease-out animate-in fade-in slide-in-from-top-1">
                    Planned maintenance: Saturday, April 18, 6:00 AM UTC (~5 min downtime). Environments may be briefly
                    unavailable - no action required.
                </span>
            }
        />
    );
};
